import { IconButton, InputAdornment, TextField } from '@material-ui/core'
import { AddIcon, PermissionsIcon, SearchIcon } from '../icons'
import React, { useEffect } from 'react'
import useDebouncedState from 'debounce'
import { strings } from '../strings'
import { Autocomplete } from '@material-ui/lab'

interface SearchProp {
  onChanged: (query: string, group: number | null) => void
  groups?: { name: string; id: number }[]
  showNew?: boolean
  onNew?: () => void
}

export function SearchPanel({ onChanged, groups, showNew, onNew }: SearchProp) {
  const [query, setQuery] = useDebouncedState('', 500)
  const [group, setGroup] = useDebouncedState<number | null>(null, 500)

  useEffect(() => {
    const exists = groups ? groups.find((x) => x.id === group) : null
    if (exists) {
      onChanged(query, group)
    } else {
      onChanged(query, null)
    }
  }, [query, group, groups, onChanged])

  return (
    <div>
      <TextField
        autoComplete="off"
        // autoFocus
        fullWidth
        onChange={(e) => setQuery(e.target.value)}
        inputProps={{ maxLength: 30 }}
        InputProps={{
          placeholder: strings.search,
          disableUnderline: true,
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end" style={{ visibility: showNew ? 'visible' : 'hidden' }}>
              <IconButton onClick={onNew}>
                <AddIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      {groups && (
        <Autocomplete
          clearOnBlur
          options={groups}
          getOptionLabel={(x) => x.name}
          onChange={(e, x: any) => setGroup(x ? x.id : null)}
          value={group ? groups.find((x) => x.id === group) : null}
          renderInput={(params) => (
            <TextField
              {...params}
              autoComplete="off"
              fullWidth
              inputProps={{
                ...params.inputProps,
                style: { unicodeBidi: 'normal' },
              }}
              InputProps={{
                ...params.InputProps,
                placeholder: strings.groupName,
                disableUnderline: true,
                startAdornment: (
                  <InputAdornment position="start">
                    <PermissionsIcon htmlColor="#333" />
                  </InputAdornment>
                ),
              }}
            />
          )}
        />
      )}
    </div>
  )
}
